import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-718fa8bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Arbeitsfläche Mast > Allgemeine Punkte", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-xl font-bold" }, "Arbeitsfläche Mast", -1))
const _hoisted_5 = { class: "content h-full max-h-full" }
const _hoisted_6 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Allgemeine Punkte", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-3 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Frage", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-5 border-solid rounded-md whiteYellowBorderColor" }, "Beschreibung/Eingabewerte", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-3" }, "Größe der Arbeitsfläche ist", -1))
const _hoisted_11 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-3" }, "Größe der Arbeitsfläche soll", -1))
const _hoisted_13 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-3" }, "Größe der Arbeitsfläche ist-soll", -1))
const _hoisted_15 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-3 mt-2" }, "Abst. Arbeitsflächengrenze ist", -1))
const _hoisted_17 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-3" }, "Abst. Arbeitsflächengrenze soll", -1))
const _hoisted_19 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-3" }, "Abst. Arbeitsflächengrenze ist-soll", -1))
const _hoisted_21 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg col-span-8" }, "Allgemeine Bilder Arbeitsfläche", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-8 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Analyse", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-5 border-solid rounded-md whiteYellowBorderColor" }, "Analyseergebnisse", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Bewertung", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Fremdobjekte auf Fläche:", -1))
const _hoisted_28 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_29 = { class: "text-xs text-gray-500 col-span-6" }
const _hoisted_30 = { class: "text-xs text-gray-500 col-span-6" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Betroffene Flurstücke", -1))
const _hoisted_32 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Nutzungsarten der Fläche:", -1))
const _hoisted_34 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_35 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_36 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Arbeitsfläche Mast > Geländebeschaffenheit (Gefälle/Ausholzung/Rodung/Graben)", -1))
const _hoisted_38 = { class: "content h-full max-h-full" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg" }, "Geländebeschaffenheit", -1))
const _hoisted_40 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Frage", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Beschreibung/Eingabewerte", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Weitere Eingaben", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Bewertung", -1))
const _hoisted_45 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_46 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_47 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Art:", -1))
const _hoisted_49 = { class: "text-xs text-gray-500" }
const _hoisted_50 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Anzahl Bäume:", -1))
const _hoisted_52 = { class: "text-xs text-gray-500" }
const _hoisted_53 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Anzahl:", -1))
const _hoisted_55 = { class: "text-xs text-gray-500" }
const _hoisted_56 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_57 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Arbeitsfläche Mast > Geländebeschaffenheit (Feuchtgebiete/Naturdenkmäler/Kampfmittel/Sonstiges)", -1))
const _hoisted_59 = { class: "content h-full max-h-full" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg" }, "Geländebeschaffenheit - Fortsetzung", -1))
const _hoisted_61 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Frage", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Beschreibung/Eingabewerte", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Weitere Eingaben", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Bewertung", -1))
const _hoisted_66 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_67 = { class: "col-span-3" }
const _hoisted_68 = { class: "text-xs text-gray-500 col-span-4" }
const _hoisted_69 = { class: "col-span-2" }
const _hoisted_70 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Art:", -1))
const _hoisted_72 = { class: "text-xs text-gray-500" }
const _hoisted_73 = { class: "text-xs text-gray-500 col-span-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tng_header = _resolveComponent("tng-header")!
  const _component_oneto_five_image_div = _resolveComponent("oneto-five-image-div")!
  const _component_bewertung_chip = _resolveComponent("bewertung-chip")!
  const _component_is_vorhanden_char_and_label = _resolveComponent("is-vorhanden-char-and-label")!
  const _component_be_footer = _resolveComponent("be-footer")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!
  const _component_Oekologie = _resolveComponent("Oekologie")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_tng_header, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"]),
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.flaechengroesse-ist'
                )?.['eingabeText']
                  ? _ctx.useIdentifierFrageFinder(
                      _ctx.ba,
                      'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.flaechengroesse-ist'
                    )?.['eingabeText'] + " m²"
                  : "-"), 1),
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.flaechengroesse-soll'
                )?.['eingabeText'] 
                  ? _ctx.useIdentifierFrageFinder(
                      _ctx.ba,
                      'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.flaechengroesse-soll'
                    )?.['eingabeText'] + " m²"
                  : "-"), 1),
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.flaechengroesse-ist-soll'
                )?.['eingabeText'] 
                  ? _ctx.useIdentifierFrageFinder(
                      _ctx.ba,
                      'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.flaechengroesse-ist-soll'
                    )?.['eingabeText'] + " m²"
                  : "-"), 1),
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.abstand-mast-bauflaechenkante-ist'
                )?.['eingabeText'] 
                  ? _ctx.useIdentifierFrageFinder(
                      _ctx.ba,
                      'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.abstand-mast-bauflaechenkante-ist'
                    )?.['eingabeText'] + " m"
                  : "-"), 1),
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.abstand-mast-bauflaechenkante-soll'
                )?.['eingabeText'] 
                  ? _ctx.useIdentifierFrageFinder(
                      _ctx.ba,
                      'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.abstand-mast-bauflaechenkante-soll'
                    )?.['eingabeText'] + " m"
                  : "-"), 1),
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.abstand-mast-bauflaechenkante-ist-soll'
                )?.['eingabeText'] 
                  ? _ctx.useIdentifierFrageFinder(
                      _ctx.ba,
                      'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.abstand-mast-bauflaechenkante-ist-soll'
                    )?.['eingabeText'] + " m"
                  : "-"), 1),
                _hoisted_22,
                _hoisted_23,
                _createVNode(_component_oneto_five_image_div, {
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.allgemein-bilder",
                  lang: _ctx.lang,
                  class: "col-span-8 ml-2"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _hoisted_24,
                _hoisted_25,
                _hoisted_26,
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.fremdobjekte-auf-flaeche'
                )?.['eingabeText']), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.fremdobjekte-auf-flaeche-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_is_vorhanden_char_and_label, {
                  ba: _ctx.ba,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.weitere-fremdobjekte-auf-flaeche",
                  label: "Weitere Fremdobjekte",
                  class: "col-span-2"
                }, null, 8, ["ba"]),
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.weitere-fremdobjekte-auf-flaeche-beschreibung')?.['eingabeText']), 1),
                _createVNode(_component_is_vorhanden_char_and_label, {
                  ba: _ctx.ba,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.betreiber-vorhanden",
                  label: "Betreiber Fremdobjekte",
                  class: "col-span-2"
                }, null, 8, ["ba"]),
                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.getAuswahlLabel(_ctx.ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.betreiber')), 1),
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.betroffeneflurstuecke')?.['eingabeText']), 1),
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.nutzungsart-der-flaeche')?.getSelectedAuswahlLabels(), (v, key) => {
                    return (_openBlock(), _createElementBlock("ul", { key: key }, [
                      (_openBlock(), _createElementBlock("li", {
                        key: key,
                        class: "text-xs text-gray-500"
                      }, _toDisplayString(v.de), 1))
                    ]))
                  }), 128))
                ]),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.nutzungsart-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"])
              ])
            ]),
            _createVNode(_component_be_footer, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["pdf-key"]),
    _createVNode(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_tng_header, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"]),
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _hoisted_42,
                _hoisted_43,
                _hoisted_44,
                _createVNode(_component_is_vorhanden_char_and_label, {
                  ba: _ctx.ba,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.gefaelle-group.gefaelle-vorhanden",
                  label: "Gefälle/Hang/Böschung",
                  class: "col-span-2"
                }, null, 8, ["ba"]),
                _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.gefaelle-group.gefaelle-beschreibung')?.['eingabeText']), 1),
                _createElementVNode("div", _hoisted_46, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'tng-be-flaechen.arbeitsflaeche-mast-tab.gefaelle-group.gefaelle-boeschung-art'
                )?.getSelectedAuswahlLabels(), (v, key) => {
                    return (_openBlock(), _createElementBlock("ul", { key: key }, [
                      (_openBlock(), _createElementBlock("li", {
                        key: key,
                        class: "text-xs text-gray-500"
                      }, _toDisplayString(v.de), 1))
                    ]))
                  }), 128))
                ]),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.gefaelle-group.gefaelle-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_oneto_five_image_div, {
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.gefaelle-group.gefaelle-bilder",
                  lang: _ctx.lang,
                  class: "col-span-8 ml-2"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_is_vorhanden_char_and_label, {
                  ba: _ctx.ba,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.ausholzung-group.ausholzung-erforderlich",
                  label: "Ausholzung erforderlich",
                  class: "col-span-2"
                }, null, 8, ["ba"]),
                _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.ausholzung-group.ausholzung-beschreibung')?.['eingabeText']), 1),
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.getAuswahlLabel(_ctx.ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.ausholzung-group.ausholzung-art')), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.ausholzung-group.ausholzung-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_oneto_five_image_div, {
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.ausholzung-group.ausholzung-bilder",
                  lang: _ctx.lang,
                  class: "col-span-8"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_is_vorhanden_char_and_label, {
                  ba: _ctx.ba,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-erforderlich",
                  label: "Rodung erforderlich",
                  class: "col-span-2"
                }, null, 8, ["ba"]),
                _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-beschreibung')?.['eingabeText']), 1),
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-anzahl-baeume')?.['eingabeText']), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_oneto_five_image_div, {
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-bilder",
                  lang: _ctx.lang,
                  class: "col-span-8"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_is_vorhanden_char_and_label, {
                  ba: _ctx.ba,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.graben-group.graben-vorhanden",
                  label: "Graben vorhanden",
                  class: "col-span-2"
                }, null, 8, ["ba"]),
                _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.graben-group.graben-beschreibung')?.['eingabeText']), 1),
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.graben-group.graben-anzahl')?.['eingabeText']), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.graben-group.graben-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_oneto_five_image_div, {
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-bilder",
                  lang: _ctx.lang,
                  class: "col-span-8"
                }, null, 8, ["ba", "immobilie", "lang"])
              ])
            ]),
            _createVNode(_component_be_footer, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["pdf-key"]),
    _createVNode(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createVNode(_component_tng_header, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"]),
            _hoisted_58,
            _createElementVNode("div", _hoisted_59, [
              _hoisted_60,
              _createElementVNode("div", _hoisted_61, [
                _hoisted_62,
                _hoisted_63,
                _hoisted_64,
                _hoisted_65,
                _createVNode(_component_is_vorhanden_char_and_label, {
                  ba: _ctx.ba,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.feuchtgebiete-group.feuchtgebiete-vorhanden",
                  label: "Feuchtgebiete vorhanden",
                  class: "col-span-2"
                }, null, 8, ["ba"]),
                _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.feuchtgebiete-group.feuchtgebiete-beschreibung')?.['eingabeText']), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.feuchtgebiete-group.feuchtgebiete-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "col-span-3 justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_oneto_five_image_div, {
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.feuchtgebiete-group.feuchtgebiete-bilder",
                  lang: _ctx.lang,
                  class: "col-span-8"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createElementVNode("div", _hoisted_67, [
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    ba: _ctx.ba,
                    fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.naturdenkmaeler-group.naturdenkmaeler-vorhanden",
                    label: "Naturdenkmäler vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["ba"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    ba: _ctx.ba,
                    fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.naturdenkmaeler-group.weitere-naturdenkmaeler-sichtbar",
                    label: "Weitere Naturdenkmäler sichtbar",
                    class: "col-span-2"
                  }, null, 8, ["ba"])
                ]),
                _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba,'tng-be-flaechen.arbeitsflaeche-mast-tab.naturdenkmaeler-group.naturdenkmaeler-beschreibung')?.['eingabeText']), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.naturdenkmaeler-group.naturdenkmaeler-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_oneto_five_image_div, {
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.naturdenkmaeler-group.naturdenkmaeler-bilder",
                  lang: _ctx.lang,
                  class: "col-span-8"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createElementVNode("div", _hoisted_69, [
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    ba: _ctx.ba,
                    fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-vorhanden",
                    label: "Kampfmittel vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["ba"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    ba: _ctx.ba,
                    fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-freimessung",
                    label: "Freimessung erforderlich",
                    class: "col-span-1"
                  }, null, 8, ["ba"])
                ]),
                _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-beschreibung')?.['eingabeText']), 1),
                _hoisted_71,
                _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba,'tng-be-flaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-art')?.['eingabeText']), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_oneto_five_image_div, {
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-bilder",
                  lang: _ctx.lang,
                  class: "col-span-8"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_is_vorhanden_char_and_label, {
                  ba: _ctx.ba,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.sonstiges-group.sonstiges-vorhanden",
                  label: "Sonstiges vorhanden",
                  class: "col-span-2"
                }, null, 8, ["ba"]),
                _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.useIdentifierFrageFinder(_ctx.ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.sonstiges-group.sonstiges-beschreibung')?.['eingabeText']), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.sonstiges-group.sonstiges-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_oneto_five_image_div, {
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  fragesPath: "tng-be-flaechen.arbeitsflaeche-mast-tab.sonstiges-group.sonstiges-bilder",
                  lang: _ctx.lang,
                  class: "col-span-8"
                }, null, 8, ["ba", "immobilie", "lang"])
              ])
            ]),
            _createVNode(_component_be_footer, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["pdf-key"]),
    _createVNode(_component_Oekologie, {
      ba: _ctx.ba,
      immobilie: _ctx.immobilie,
      lang: _ctx.lang,
      oekologie: _ctx.ba.findFragenblockByRelativePath('arbeitsflaeche-mast-tab.oekologie-group')!,
      "bread-crumb": "Arbeitsfläche Mast > Ökologie",
      tab: "Arbeitsfläche"
    }, null, 8, ["ba", "immobilie", "lang", "oekologie"])
  ], 64))
}